import { IPagination } from 'app/types/common';

export interface ITeamMemberSummary {
  fullName: string;
  email: string;
  mobile: string;
  createdAt: Date;
  updatedAt: Date;
  status: null;
  teamName: string;
  team: {
    id: string;
  };
  consumer: {
    id: string;
  };
  financialStatus: string;
  pendingTeamPaymentCollectionsTotalCount: number;
  paidTeamPaymentCollectionsTotalCount: number;
  overdueTeamPaymentCollectionsTotalCount: number;
  pendingTeamPaymentCollectionsTotalAmount: number;
  paidTeamPaymentCollectionsTotalAmount: number;
  overdueTeamPaymentCollectionsTotalAmount: number;
}
export interface ITeamMemberSummariesState {
  readonly teamMemberSummariesById?: any;
  readonly teamMemberSummaryIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddTeamMemberSummary?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationTeamMemberSummaryIds?: string[];
  readonly currentTeamMemberSummaryId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface ITeamMemberSummariesSelector extends ITeamMemberSummariesState {
  readonly currentTeamMemberSummary?: any;
  readonly currentFormTeamMemberSummary?: any;
  readonly getTeamMemberSummariesFilteredByTagInSelectFormat?: any;
  readonly teamMemberSummariesByIdInSelectFormat?: any;
}

export enum TeamMemberSummariesActionTypes {
  GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_REQUESTED = 'redux-app/team-member-summaries/GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_REQUESTED',
  GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_PENDING = 'redux-app/team-member-summaries/GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_PENDING',
  GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_SUCCESS = 'redux-app/team-member-summaries/GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_SUCCESS',
  GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_FAIL = 'redux-app/team-member-summaries/GET_ALL_TEAM_MEMBER_SUMMARY_SUMMARIES_FAIL',
  GET_TEAM_MEMBER_SUMMARY_REQUESTED = 'redux-app/team-member-summaries/GET_TEAM_MEMBER_SUMMARY_REQUESTED',
  GET_TEAM_MEMBER_SUMMARY_PENDING = 'redux-app/team-member-summaries/GET_TEAM_MEMBER_SUMMARY_PENDING',
  GET_TEAM_MEMBER_SUMMARY_SUCCESS = 'redux-app/team-member-summaries/GET_TEAM_MEMBER_SUMMARY_SUCCESS',
  GET_TEAM_MEMBER_SUMMARY_FAIL = 'redux-app/team-member-summaries/GET_TEAM_MEMBER_SUMMARY_FAIL',
  UPDATE_TEAM_MEMBER_SUMMARY_REQUESTED = 'redux-app/team-member-summaries/UPDATE_TEAM_MEMBER_SUMMARY_REQUESTED',
  UPDATE_TEAM_MEMBER_SUMMARY_PENDING = 'redux-app/team-member-summaries/UPDATE_TEAM_MEMBER_SUMMARY_PENDING',
  UPDATE_TEAM_MEMBER_SUMMARY_SUCCESS = 'redux-app/team-member-summaries/UPDATE_TEAM_MEMBER_SUMMARY_SUCCESS',
  UPDATE_TEAM_MEMBER_SUMMARY_FAIL = 'redux-app/team-member-summaries/UPDATE_TEAM_MEMBER_SUMMARY_FAIL',
  CREATE_TEAM_MEMBER_SUMMARY_REQUESTED = 'redux-app/team-member-summaries/CREATE_TEAM_MEMBER_SUMMARY_REQUESTED',
  CREATE_TEAM_MEMBER_SUMMARY_PENDING = 'redux-app/team-member-summaries/CREATE_TEAM_MEMBER_SUMMARY_PENDING',
  CREATE_TEAM_MEMBER_SUMMARY_SUCCESS = 'redux-app/team-member-summaries/CREATE_TEAM_MEMBER_SUMMARY_SUCCESS',
  CREATE_TEAM_MEMBER_SUMMARY_FAIL = 'redux-app/team-member-summaries/CREATE_TEAM_MEMBER_SUMMARY_FAIL',
  DELETE_TEAM_MEMBER_SUMMARY_REQUESTED = 'redux-app/team-member-summaries/DELETE_TEAM_MEMBER_SUMMARY_REQUESTED',
  DELETE_TEAM_MEMBER_SUMMARY_PENDING = 'redux-app/team-member-summaries/DELETE_TEAM_MEMBER_SUMMARY_PENDING',
  DELETE_TEAM_MEMBER_SUMMARY_SUCCESS = 'redux-app/team-member-summaries/DELETE_TEAM_MEMBER_SUMMARY_SUCCESS',
  DELETE_TEAM_MEMBER_SUMMARY_FAIL = 'redux-app/team-member-summaries/DELETE_TEAM_MEMBER_SUMMARY_FAIL',
  SELECT_TEAM_MEMBER_SUMMARY_REQUESTED = 'redux-app/team-member-summaries/SELECT_TEAM_MEMBER_SUMMARY_REQUESTED',
  CLEAR_TEAM_MEMBER_SUMMARY_SUMMARIES = 'redux-app/team-member-summaries/CLEAR_TEAM_MEMBER_SUMMARY_SUMMARIES',
}

export default null;
